import React from 'react';

interface MomentumBadgeProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
}

export default function MomentumBadge({ score, size = 'md' }: MomentumBadgeProps) {
  const level = score >= 80 ? 'high' : score >= 55 ? 'medium' : 'low';
  const colorMap = {
    high: 'text-positive border-positive/30 bg-positive/10',
    medium: 'text-warning border-warning/30 bg-warning/10',
    low: 'text-negative border-negative/30 bg-negative/10',
  };
  const sizeMap = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-xs px-2.5 py-1',
    lg: 'text-sm px-3 py-1.5',
  };

  return (
    <span className={`inline-flex items-center gap-1 font-700 rounded-full border font-mono ${colorMap[level]} ${sizeMap[size]}`}>
      <span className="text-xs">⚡</span>
      {score}
    </span>
  );
}